import Header from "../components/dashboard/Header";
import MusicPanel from "../components/MusicPanel";

export default function Music() {
  return (
    <div className="min-h-screen bg-brand-page">
      <Header />
      <main className="max-w-[1600px] mx-auto px-6 lg:px-12 py-10">
        <div className="mb-8">
          <h1 className="font-serif text-4xl sm:text-5xl text-brand-ink tracking-tight" data-testid="music-title">Music</h1>
          <p className="text-sm text-brand-muted mt-2">
            Sonos control across every location — play, pause and skip per room, set group &amp; per-speaker volume,
            pick playlists, and schedule what plays during open hours.
          </p>
        </div>
        <MusicPanel showHeaders />
      </main>
    </div>
  );
}
